import styled from "@emotion/styled";
import { Colors, FontWeight, Fonts } from "@snapchat/snap-design-system";

export const LensDestinationsText = styled.span`
    ${Fonts.Heading.H900}
    overflow: hidden;

    max-width: 100px;

    font-weight: ${FontWeight.MEDIUM};
    color: ${Colors.Gray.V300};
    text-overflow: ellipsis;
    white-space: nowrap;
`;
